"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalorieBudgetNutritionWeekItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const NutritionWeekFact_1 = __importDefault(require("./NutritionWeekFact"));
const typography_1 = require("../../shared/typography");
const hooks_1 = require("../../shared/hooks");
const resolveFactText = (factValue, unit) => {
    return ((0, jsx_runtime_1.jsxs)(typography_1.P, { children: [`${Math.round(factValue)}`, (0, jsx_runtime_1.jsx)("span", { children: `${unit}` }, void 0)] }, void 0));
};
const CalorieBudgetNutritionWeekItem = (props) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: props.isTrainingDay
                    ? props.translations.trainingDay
                    : props.translations.nonTrainingDay }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveFactText(props.calorieBudget.calories, props.translations.kcal) }, void 0), !isMobile && [
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveFactText(props.calorieBudget.carbohydrates, props.unit) }, props.calorieBudget.carbohydrates),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveFactText(props.calorieBudget.proteins, props.unit) }, props.calorieBudget.proteins),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveFactText(props.calorieBudget.fats, props.unit) }, props.calorieBudget.fats),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveFactText(props.calorieBudget.fibers, props.unit) }, props.calorieBudget.fibers)
                    ]] }, void 0)] }, void 0));
};
exports.CalorieBudgetNutritionWeekItem = CalorieBudgetNutritionWeekItem;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  h2,
  p {
    margin-bottom: 0;
  }

  & > div {
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }

  & > div:first-of-type > div:first-of-type span {
    display: none;
  }

  & > div:first-of-type > div span:before {
    content: " ";
  }

  & > div > div {
    justify-self: flex-end;
    margin-left: ${({ theme }) => theme.spacings.s};
  }

  & > div p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    font-size: 0.875rem;
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    border-left: none;
    border-right: none;
    padding: ${({ theme }) => theme.spacings.m};

    & > div > div:last-of-type {
      display: flex;
      justify-content: flex-end;
    }

    & > div:first-of-type > div:first-of-type span {
      display: inline;
      text-transform: lowercase;
    }

    p span:empty {
      display: none;
    }
  }
`;
//# sourceMappingURL=CalorieBudgetNutritionWeekItem.js.map